import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LandingPage from './components/Landing/LandingPage';
import AboutUs from './components/Landing/AboutUs'; // 1. Importe o componente AboutUs
import CarrinhosLandingPage from './components/Landing/CarrinhosLandingPage'; // Nova rota
import { UserProvider } from './contexts/UserContext';

function App() {
  return (
    <Router>
      <UserProvider>
        <div className="App">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            {/* 2. Adicione a nova rota para a página Sobre Nós */}
            <Route path="/sobre-nos" element={<AboutUs />} />
            <Route path="/carrinhos" element={<CarrinhosLandingPage />} />
            {/* Outras rotas, como /login, /terms, etc. */}
          </Routes>
        </div>
      </UserProvider>
    </Router>
  );
}

export default App;